/**
 * Bộ khởi tạo cho người phát triển module (ADR-0113): danh mục là tệp tĩnh `/dev-kits/index.json` nằm cùng image giao
 * diện, do bước build sinh từ `modules/*`. Không qua Gateway nên không cần token; tải tệp zip là liên kết tĩnh.
 */
import { dungApiThat } from '../api/http';
import type { ApiError } from '../errors';
import { mockRequest } from '../../mock/transport';
import { danhMucBoKhoiTaoGia } from '../../mock/bo-khoi-tao';
import { TEP_DANH_MUC, chuanHoaDanhMuc } from '../../modules/module-to-chuc/nghiep-vu/bo-khoi-tao';
import type { DanhMucBoKhoiTao } from '../../modules/module-to-chuc/types';

/**
 * Lỗi đi qua `giaiLoi`: mã `NETWORK_ERROR` và `NOT_FOUND` có câu dịch sẵn; `SYSTEM_INTERNAL_ERROR` không kèm câu thì
 * rơi về câu mặc định. `message` chỉ để dò lỗi, người dùng không thấy.
 */
async function docDanhMuc(): Promise<DanhMucBoKhoiTao> {
  let res: Response;
  try {
    res = await fetch(TEP_DANH_MUC, { headers: { Accept: 'application/json' }, cache: 'no-cache' });
  } catch {
    throw { code: 'NETWORK_ERROR', message: 'network error' } satisfies ApiError;
  }
  // Bản chưa có danh mục: nginx trả trang index.html (200, text/html) cho đường dẫn lạ
  const laJson = (res.headers.get('content-type') ?? '').includes('json');
  if (!res.ok || !laJson) {
    throw { code: 'NOT_FOUND', status: res.status, message: `${TEP_DANH_MUC} not found` } satisfies ApiError;
  }
  try {
    return chuanHoaDanhMuc(await res.json());
  } catch {
    throw { code: 'SYSTEM_INTERNAL_ERROR', status: res.status, message: '' } satisfies ApiError;
  }
}

export const boKhoiTaoRepository = {
  /** `GET /dev-kits/index.json` (tệp tĩnh, không qua `/api`). */
  danhMuc: (): Promise<DanhMucBoKhoiTao> =>
    dungApiThat() ? docDanhMuc() : mockRequest(danhMucBoKhoiTaoGia(), { sdk_version: '', items: [] }),
};
